import logoUrl from '../../../assets/autonome-logo-on-dark.png'

/**
 * The autonoME logo (heart with a clock, and the wordmark) for the shells'
 * dark header: the original artwork (`assets/autonome-logo.jpg`, on white)
 * with its background cut away and the marine "autono" turned white, since
 * marine on the header's dark marine cannot be read.
 */
export function BrandLogo({ className = 'h-11' }: { className?: string }) {
  return <img src={logoUrl} alt="autonoME" className={`${className} w-auto shrink-0`} />
}
